module.exports = __webpack_public_path__ + "img/BAAC.00e03536.png";